import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AttendeeReviewPage from '../../app-attendee-review-page/AttendeeReviewPage';
import { fetchReview } from '../actions/reviews';
import { get, isEmpty } from 'lodash';
import { Spinner } from 'shared-components/decorators/spinner';

class AttendeeReviewContainer extends Component {
  componentDidMount () {
    const reviewId = get(this.props, 'routeParams.reviewId');
    const { dispatch, accessToken } = this.props;

    dispatch(fetchReview(reviewId, accessToken));
  }

  componentDidUpdate () {
    const { isFetched, reviewFailedToLoad, userIsReviewer, accessToken } = this.props;
    const currentPath = window.location.pathname;
    if (isFetched && (reviewFailedToLoad || !userIsReviewer)) {
      // if the user isn't signed in, redirect to signin, then send back here for another check
      if (!accessToken) {
        location.href = `${`/signin?dest=${encodeURIComponent(currentPath)}`}`;
      } else {
        // if the user is signed in and the review failed to load or they are the incorrect user
        location.href = `${location.origin}`;
      }
    }
  }

  render () {
    const { isFetched, reviewFailedToLoad, userIsReviewer } = this.props;
    const reviewId = get(this.props, 'routeParams.reviewId');

    return (
      <div>
        { isFetched && !reviewFailedToLoad && userIsReviewer
          ? <AttendeeReviewPage reviewId={reviewId} {...this.props} />
          : <div className="spinner-container">
            <Spinner additionalStyle="gray" />
          </div>

        }
      </div>
    );
  }
}

AttendeeReviewContainer.propTypes = {
  isFetched: PropTypes.bool,
  review: PropTypes.object,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  userSsoId: PropTypes.string
};

const mapStateToProps = (state = {}, props) => {
  const reviewId = get(props, 'routeParams.reviewId');
  const isFetched = get(state, 'reviews.isFetched');
  const review = get(state, `reviews[${reviewId}]`, {});
  const userSsoId = get(state, 'profile.SSOid');
  const reviewFailedToLoad = isFetched && isEmpty(review);
  const userIsReviewer = userSsoId === review.reviewer_id;

  return {
    accessToken: get(state, 'auth.accessToken'),
    isFetched,
    review,
    userSsoId,
    reviewFailedToLoad,
    userIsReviewer
  };
};

export default connect(mapStateToProps)(AttendeeReviewContainer);
